// https://github.com/alphagov/govuk-frontend/blob/master/src/globals/scss/settings/_spacing.scss
export var RESPONSIVE_0 = {
  mobile: 0,
  tablet: 0
};
export var RESPONSIVE_1 = {
  mobile: 5,
  tablet: 5
};
export var RESPONSIVE_2 = {
  mobile: 10,
  tablet: 10
};
export var RESPONSIVE_3 = {
  mobile: 15,
  tablet: 15
};
export var RESPONSIVE_4 = {
  mobile: 15,
  tablet: 20
};
export var RESPONSIVE_5 = {
  mobile: 15,
  tablet: 45
};
export var RESPONSIVE_6 = {
  mobile: 20,
  tablet: 30
};
export var RESPONSIVE_7 = {
  mobile: 25,
  tablet: 40
};
export var RESPONSIVE_8 = {
  mobile: 30,
  tablet: 50
};
export var RESPONSIVE_9 = {
  mobile: 40,
  tablet: 60
};
export var SPACING_MAP = [RESPONSIVE_0, RESPONSIVE_1, RESPONSIVE_2, RESPONSIVE_3, RESPONSIVE_4, RESPONSIVE_5, RESPONSIVE_6, RESPONSIVE_7, RESPONSIVE_8, RESPONSIVE_9];
export var SPACING_MAP_INDEX = Array.from(Array(SPACING_MAP.length).keys());
//# sourceMappingURL=spacing.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/constants/es/spacing.js
// module id = 24
// module chunks = 0